import React from 'react';
import CovidQuestions from "./CovidQuestions";
import ChestQuestions from "./ChestQuestions";
import ImagEDMammoQuestions from "./ImagEDMammoQuestions";
import ImagEDChestQuestions from "./ImagEDChestQuestions";
import UltrasoundQuestion from './UltrasoundQuestion';
import ChestCTQuestions from "./ChestCTQuestion";
import LinEDQuestions from "./LinEDQuestions";
import QuizQuestions from './QuizQuestions';
import PollQuestions from './PollQuestions';
import WBCTQuestions from './WBCTQuestions';
import InteractiveVideoQuestion from './InteractiveVideoQuestion';
import ChestMultiDiseaseQuestion from './ChestMultiDiseaseQuestion';
import BreastEDMRIQuestions from "./BreastEDMRIQuestions";
import DynamicQuestions from './DynamicQuestions';
import LungEDUKQuestions from "./LungEDUKQuestions";

const SideQuestions = React.forwardRef((props, ref) => {
    const {modality_type, name} = props.modalityInfo;

    if ((props.questions && props.questions.length > 0) || props.confidenceQuestion) {
        const quizMode = ['video_lecture', 'quiz'].includes(modality_type);
        return <DynamicQuestions
            ref={ref}
            questions={props.questions}
            testCaseId={props.test_case_id}
            attemptId={props.attempts_id}
            isPostTest={props.isPostTest}
            confidenceQuestion={props.confidenceQuestion}
            complete={props.complete}
            quizMode={quizMode}
        />;
    }

    switch (modality_type) {
        case 'covid':
            return <CovidQuestions ref={ref} {...props} />
        case 'chest':
            return name !== 'LinED' ? <ChestQuestions ref={ref} {...props} /> : <LinEDQuestions ref={ref} {...props} />
        case 'imaged_mammo':
            return <ImagEDMammoQuestions ref={ref} {...props} />
        case 'imaged_chest':
            return <ImagEDChestQuestions ref={ref} {...props} />
        case 'ultrasound':
            return <UltrasoundQuestion ref={ref} {...props} />
        case 'chest_ct':
            return name !== 'Chest Multi Disease' ? <ChestCTQuestions ref={ref} {...props} /> : <ChestMultiDiseaseQuestion ref={ref} {...props} />
        case 'quiz':
        case 'video_lecture':
        // case 'presentations':
            return <QuizQuestions ref={ref} {...props} />
        case 'poll':
            return <PollQuestions ref={ref} {...props} />
        case 'wb_ct':
            return <WBCTQuestions ref={ref} {...props} />
        case 'interactive_video':
            return <InteractiveVideoQuestion ref={ref} {...props} />
        case 'lung_ed_uk':
            return <LungEDUKQuestions ref={ref} {...props} />
        case 'breasted_mri':
            return <BreastEDMRIQuestions ref={ref} {...props} />
        default:
            return null;
    }
});

export default SideQuestions;
